import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    order: {
      goodsList: [],
      address: {}
    },
    userInfo: {
      patientId: null,
    },
    doctor: {},
    tempGift: {},
    keepList: [], // 缓存页面列表
  },
  getters: {
    getUserInfo: (state) => state.userInfo,
    getKeepList: (state) => state.keepList,
  },
  mutations: {
    setGoodsList(state, list = []) {
      state.order.goodsList = list;
    },
    setOrderAddress(state, data) {
      state.order.address = data;
    },
    setPatientId(state, val) {
      state.userInfo.patientId = val;
    },
    setKeepList(state, payload) {
      state.keepList = payload;
    },
    setDoctor(state, data) {
      state.doctor = data;
    },
    saveTempGift(state, data) {
      state.tempGift = data;
    },
  },
  actions: {
    setPatientId({ commit }, val) {
      commit('setPatientId', val);
    },
  },
  modules: {},
});
